import { FetchAPI } from '@renedelangel/helpers';
import { urlServidor } from '../../helpers';

const CAMPOS = `
    seguimientoSemanalSegID
    seguimientoSeguroID
    comentario
    avance
    fechaSeguimiento
    personalSeguimiento
    seguimientoProgramaID
    avancePrograma
`;

export const ADD_SEGUIMIENTOSEMANALSEG = `
mutation addSeguimientoSemanalSeg($input: InputAddSeguimientoSemanalSeg!){
    addSeguimientoSemanalSeg(input: $input){
        ${CAMPOS}
    }
}
`;

export const UPDATE_SEGUIMIENTOSEMANALSEG = `
mutation updateSeguimientoSemanalSeg($input: InputUpdateSeguimientoSemanalSeg!){
    updateSeguimientoSemanalSeg(input: $input){
        ${CAMPOS}
    }
}
`;

export const DELETE_SEGUIMIENTOSEMANALSEG = `
mutation deleteSeguimientoSemanalSeg($input: InputDeleteSeguimientoSemanalSeg){
    deleteSeguimientoSemanalSeg(input: $input)
}
`;

export const addSeguimientoSemanalSeg = async (variables, token) => {
    try {
        let { addSeguimientoSemanalSeg } = await FetchAPI.graphql({
            token,
            variables,
            url: urlServidor,
            query: ADD_SEGUIMIENTOSEMANALSEG
        });
        return addSeguimientoSemanalSeg;
    } catch ({ message }) { throw new Error(message); }
};

export const updateSeguimientoSemanalSeg = async (variables, token) => {
    try {
        let { updateSeguimientoSemanalSeg } = await FetchAPI.graphql({
            token,
            variables,
            url: urlServidor,
            query: UPDATE_SEGUIMIENTOSEMANALSEG
        });
        return updateSeguimientoSemanalSeg;
    } catch ({ message }) { throw new Error(message); }
};

export const deleteSeguimientoSemanalSeg = async (input, token) => {
    try {
        let { deleteSeguimientoSemanalSeg } = await FetchAPI.graphql({
            token,
            variables: { input },
            url: urlServidor,
            query: DELETE_SEGUIMIENTOSEMANALSEG
        });
        return deleteSeguimientoSemanalSeg;
    } catch ({ message }) { throw new Error(message); }
};
